import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 4rem 1.5rem;
  min-height: 70vh;
  text-align: center;
`;

export const SuccessIcon = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #4caf50;
  color: white;
  font-size: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);
`;

export const Title = styled.h1`
  font-family: 'Abel', sans-serif;
  font-size: 2.5rem;
  font-weight: 300;
  letter-spacing: 1px;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 1rem;
`;

export const OrderNumber = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 1.2rem;
  font-weight: 600;
  color: #b8964a;
  margin-bottom: 2rem;
`;

export const Message = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.8;
  margin-bottom: 3rem;

  p {
    margin: 0.5rem 0;
  }
`;

export const InfoBox = styled.div`
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 2rem;
  margin: 2rem 0;
  text-align: left;
`;

export const InfoTitle = styled.h3`
  font-family: 'Abel', sans-serif;
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 1rem;
`;

export const InfoList = styled.ul`
  font-family: 'Abel', sans-serif;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.8;
  padding-left: 1.5rem;

  li {
    margin: 0.5rem 0;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 3rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const HomeButton = styled.button`
  flex: 1;
  max-width: 250px;
  background-color: white;
  border: 2px solid #b8964a;
  color: #b8964a;
  font-family: 'Abel', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 1rem 2rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background-color: #b8964a;
    color: white;
  }
`;

export const ShopButton = styled.button`
  flex: 1;
  max-width: 250px;
  background-color: #b8964a;
  border: none;
  color: white;
  font-family: 'Abel', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 1rem 2rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background-color: #a0864a;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(184, 150, 74, 0.3);
  }
`;